module.exports = __webpack_public_path__ + "static/img/19051C_2_R_20200721_fit.b825d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19051C_2_R_20200721_fit.png
// module id = HGf4
// module chunks = 0